type UserInfoLike = {
  displayName?: string | null
  name?: string | null
  givenName?: string | null
  familyName?: string | null
  email?: string | null
}

const RAM_USER_PREFIX = 'user-'

/**
 * RAM identifies a member or guest by its principal type: a user shows up as `user-{userId}`, a team
 * as `team-{teamId}`. Anything that stores a plain platform user id — an on-call list, a member
 * insert — needs the bare id, so strip the prefix before handing an id on.
 */
export const extractRamUserId = (memberId: string): string =>
  memberId.startsWith(RAM_USER_PREFIX) ? memberId.slice(RAM_USER_PREFIX.length) : memberId

export const resolveDisplayName = (userInfo?: UserInfoLike | null): string | null => {
  if (!userInfo) return null
  return (
    userInfo.displayName ||
    userInfo.name ||
    [userInfo.givenName, userInfo.familyName].filter(Boolean).join(' ') ||
    userInfo.email ||
    null
  )
}
